
<template>
<div class='' style="width:100%;height:100%;margin: 0px;padding:0px;position: relative;  background-color: rgb(237, 239, 239);overflow: auto;" @scroll.passive="scrollTop($event)">
  <Nav @mouseover.native="navOpacity=1" @mouseleave.native="ml()" :style="`opacity:${navOpacity};z-index:1;${navOpacity==0?'display:none':''}`" :navList="navList" :type="'image'" :changeClassify="changeClassify" :ssindex="ssindex"></Nav>
  <!-- <div :style="`opacity:${navOpacity};`" style="position:fixed;left:94%;margin-left:-270px;top:80px;z-index:100;" @mouseleave="changeAgeStatus(0)" @mouseover="changeAgeStatus(1)"> -->
    <div id="allAgeType" :style="`opacity:${navOpacity};`" @mouseleave="changeAgeStatus(0)" @mouseover="changeAgeStatus(1)">
    <!-- <div v-if="ageStatus==0" style="display:flex;justify-content:flex-end;border:1px solid black;border-radius: 16px;height:40px;align-items: center;margin-left:115px">
      <h2 class="selected" style="cursor:pointer;font-size:26px;padding:5px 15px 5px 15px;border-radius:14px;letter-spacing: 5px;" @click="selectByType(2)">{{ageType}}</h2>
    </div>   -->
    <div id="kidAge">
      <h2 @click="selectByType(2)" :class="type==2?'selected':''">大童</h2>
      <h3 @click="selectByType(1)" :class="type==1?'selected':''">小童</h3>
    </div>
  <!-- <div class="corControl">
        <svg width="40" height="40" viewBox="0 0 100 100" @click="toTop()">
          <polygon
            class="corDirection"
            stroke-linejoin="round"
            points="25,40 45,20 65,40 "
          />
        </svg>
  </div> -->
  </div>
    <div id="show">
      <div v-if="corData==undefined||corData.length==0">
        <el-image style="width:100%;height:98%;border-radius: 15px;border:1px solid gray;display: flex;align-items: center;justify-content: center;cursor:auto;" :src="'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'">
          <div slot="error" style="font-size:25px;color:gray">
            {{ message }}
          </div>
        </el-image>
      </div>
      
      <div v-show="corData.length>0" v-for="(item,index) in corData" :key="index">
      <el-image style="border-radius: 15px;margin-bottom: 20px;width:100%;height:100%" :src="item.backImgOne" :preview-src-list="imgs" lazy  @mouseover="showOther(index,$event.target)" @mouseenter="showOther(index,$event.target)" @mouseleave="show(index,$event.target)"></el-image>
      </div>
      <!-- <div v-show="corData.length=0">
         <span style="text-align:center">暂无该数据</span>
      </div> -->
    </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Nav from '@/components/Nav.vue'
import {queryList,querySort,addNum} from '@/api/web/corporateImage'
import {loadingTime} from '@/utils/const.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {Nav},
data() {
//这里存放数据
return {
//  navList:["2O22/SS","2O22/AW","2O21/SS","2O21/AW"],
//  otherImageList:[require("../../assets/形象展示/形象大片/2.png"),require("../../assets/形象展示/形象大片/2.png"),],
//  imageList:[require("../../assets/形象展示/形象大片/1.png"),require("../../assets/形象展示/形象大片/1.png"),],
navList:[],
 type:1,
 corData:[],
 imgs:[],
 sortData:[],
 ssindex:-1,
 navOpacity:1,
 scrollPos:0,
 ageType:"小童",
 ageStatus:0,
 message:"图片加载中......"
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
  corData(val){
    if(val!=null&&val!=undefined&&val.length>0){
      for(var i = 0;i < this.corData.length; i++){
        this.imgs.push(this.corData[i].backImgOne)
        this.imgs.push(this.corData[i].backImgTwo)
      }
    }
  },
  '$route'(){
    var _this = this
    _this.corData=[]
    setTimeout(()=>{
      if(_this.corData==undefined||_this.corData==null||_this.corData.length==0)
      _this.message="图片加载失败"
    },loadingTime)
    queryList({"classify":_this.$route.params.id,"type":_this.type}).then(({data})=>{
    _this.corData=data
 },()=>{
  _this.message="图片加载失败"
 })
  }
},
//方法集合
methods: {
  changeAgeStatus(type){
    setTimeout(()=>{
      this.ageStatus=type
    },500)
  },
  ml(){
    //这里本来是设计页面下移导航栏透明的，但是要求取消
    // if(this.scrollPos>0){
    //   this.navOpacity = 0.4
    // }else{
    //   this.navOpacity = 1
    // }

  },
  scrollTop(){ 
    if (window.pageYOffset) {  
    this.scrollPos = window.pageYOffset; }  
    else if (document.compatMode && document.compatMode != 'BackCompat')  
    { this.scrollPos = document.documentElement.scrollTop; }  
    else if (document.body) { this.scrollPos = document.body.scrollTop; }   
    if(this.scrollPos>5){
      this.navOpacity = 0 //下移直接隐藏
    }else{
      this.navOpacity = 1
    }
  },
  selectByType(type){
    var _this = this
    if(type==1){
      this.ageType="小童"
    }else{
      this.ageType="大童"
    }
    queryList({"classify":_this.$route.params.id,"type":type}).then(({data})=>{
      _this.corData=data
      _this.type=type
    })
  },
  showOther(index,target){
    target.src=this.corData[index].backImgTwo
  },
  show(index,target){
    target.src=this.corData[index].backImgOne
  },
  toTop(){
    window.scrollTo({
      top:0,
      behavior:"smooth"
    })
  },
  changeClassify(val){
    var _this = this
    var id = ""
    for(var i=0;i<_this.sortData.length;i++){
      if(_this.sortData[i].name==val){
         id=_this.sortData[i].id
         break
      }
    }
    addNum({id:id})
   this.$router.push({name:'corporateImageShow',params:{id:id}})
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 var _this = this
 window.addEventListener('scroll', this.scrollTop)
 queryList({"classify":_this.$route.params.id,"type":_this.type}).then(({data})=>{
  _this.corData=data
 })
 querySort().then(({data})=>{
  _this.sortData=data
  if(_this.sortData==undefined||_this.sortData.length==0){
    _this.navList.push("无分类信息......")
  }else{
      for(var i=0;i<_this.sortData.length;i++){
      _this.navList.push(_this.sortData[i].name)
      if(_this.$route.params.id==_this.sortData[i].id){
        _this.ssindex=i
      }
    }
  }
 },()=>{_this.navList.push("无分类信息.......")})
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类
#show div{
  box-sizing: border-box;
  width:367.5px;
  // min-height:560px;
  height: 550px;
  float:left;
  margin-bottom:70px;
  cursor: pointer;
  position: relative;
  
  ::v-deep .el-image__inner {
    object-fit: cover !important;
    width: 100% !important;
    height: 100% !important;
  }
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 45%;
    margin-right: 5%;
    height: 450px;
  }
  
  @media screen and (max-width: 768px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
    height: 560px;
  }
}

#show{
  height:auto;
  width:1680px;
  margin-top:11%;
  margin-left:6%;
  display: inline-block;
  
  @media screen and (max-width: 1024px) and (min-width: 769px) {
    width: 90%;
    margin-left: 5%;
    margin-top: 100px;
  }
  
  @media screen and (max-width: 768px) {
    width: 95%;
    margin-left: 2.5%;
    margin-top: 120px;
  }
}

#show div:nth-child(4n+4){
  margin-right: 0px;
}

#show div:not(:nth-child(4n+4)){
  margin-right:4%;
  
  @media screen and (max-width: 768px) {
    margin-right: 0;
  }
}

.corControl{
  width: 100px;
  height: 100px;
  border: none;
  border-radius: 100px;
  cursor: pointer;
}
.corDirection {
  fill: rgb(0, 0, 0);
  stroke: rgb(0, 0, 0);
  stroke-width: 15;
}
.selected{
  color:white;
  background-color: black;
}
// #allAgeType:hover{
//   animation-name: toAllAgeType;
//   animation-fill-mode: forwards;
//   animation-direction: alternate;
//   animation-duration: 1s;
// }
#allAgeType{
  // animation-name: toSingleAgeType;
  // animation-fill-mode: forwards;
  // animation-direction: alternate;
  // animation-duration: 1s;
  position:fixed;
  left:94%;
  margin-left:-270px;
  top:85px;
  z-index:100;
  
  @media screen and (max-width: 768px) {
    left: auto;
    right: 10px;
    margin-left: 0;
    top: 60px;
  }
}

@keyframes toAllAgeType {
  0%{
    opacity: 1;
  }
  50%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
@keyframes toSingleAgeType {
  0%{
    opacity: 1;
  }
  50%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
}
#kidAge{
  display:flex;
  justify-content:space-between;
  border:1px solid black;
  border-radius: 16px;
  height:38px;
  align-items: center;
  margin-left: 20px;
  
  @media screen and (max-width: 768px) {
    margin-left: 0;
    height: 32px;
  }
}
#kidAge h2{
  cursor:pointer;
  font-size:26px;
  padding:5px 12px 3px 12px;
  border-radius:14px;
  letter-spacing: 5px;
  
  @media screen and (max-width: 768px) {
    font-size: 18px;
    padding: 3px 8px;
  }
}
#kidAge h3{
  cursor:pointer;
  font-size:26px;
  padding:5px 12px 3px 12px;
  border-radius:14px;
  letter-spacing: 5px;
  
  @media screen and (max-width: 768px) {
    font-size: 18px;
    padding: 3px 8px;
  }
}
// h2{
//   border-bottom:3px solid black;
//   text-align:center;
//   font-size: 25px;
//   margin:0px;
//   padding-bottom:3px;
//   cursor: pointer;
//   color:gray
// }
// h3{
//   text-align:center;
//   font-size:25px;
//   margin:0px;
//   padding-top:8px;
//   cursor: pointer;
//   color:gray;
// }
</style>